import { useHistory } from "react-router-dom"
import { useI18n } from "providers/I18n"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { StyledFilterInput } from "./StyledFilterInput"

const applicableScenario = [
  {
    year: "2020",
    options: [{ label: "ACT", value: "ACT" }],
    default: "ACT",
  },
  {
    year: "2021",
    options: [
      { label: "1RE", value: "1RE" },
      { label: "2RE", value: "2RE" },
      { label: "3RE", value: "3RE" },
      { label: "ACT", value: "ACT" },
    ],
    default: "ACT",
  },
  {
    year: "2022",
    options: [
      { label: "1RE", value: "1RE" },
      { label: "2RE", value: "2RE" },
      { label: "3RE", value: "3RE" },
      { label: "BUD", value: "BUD" },
      { label: "ACT", value: "ACT" },
    ],
    default: "3RE",
  },
  {
    year: "2023",
    options: [
      { label: "1RE", value: "1RE" },
      { label: "2RE", value: "2RE" },
      { label: "3RE", value: "3RE" },
      { label: "FP", value: "FP" },
      { label: "BUD", value: "BUD" },
      { label: "ACT", value: "ACT" },
    ],
    default: "ACT",
  },
  {
    year: "2024",
    options: [
      { label: "FP", value: "FP" },
      { label: "BUD", value: "BUD" },
    ],
    default: "FP",
  },
]

export function FilterScenario() {
  const { t } = useI18n()
  const history = useHistory()
  const { pathname, search, scenarioParam, yearParam } = useRevenueParams()

  const scenario = applicableScenario.find((item) => item.year === yearParam)

  const currentAllowed = scenario?.options.find(
    (item) => item.value === scenarioParam,
  )
  if (!currentAllowed && scenarioParam !== scenario?.default) {
    const updatedUrl = new URLSearchParams(search)
    if (!!scenario?.default) {
      updatedUrl.set("scenario", scenario.default)
      history.push({ pathname, search: updatedUrl.toString() })
    }
  }

  const scenarioOptions = scenario?.options || [{ label: "", value: "" }]

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedUrl = new URLSearchParams(search)
    updatedUrl.set("scenario", e.target.value)

    history.push({ pathname, search: updatedUrl.toString() })
  }

  return (
    <StyledFilterInput
      name="scenario"
      label={t("revenue.filter.scenario")}
      value={scenarioParam}
      options={scenarioOptions}
      onChange={onChange}
    />
  )
}
